import { NOTIFICATION_TYPES } from '@/common/constants/notifications.constants';
import { store } from '@/common/root';
import { Notification } from '@uikit/ui-kit';
import type { ElNotification, ElNotificationOptions } from '@uikit/ui-kit/types/notification';

type Notify = ElNotification & ((options: ElNotificationOptions) => ElNotification | Promise<any>);

let $notify: Notify;

const getNotify = () => {
  if ($notify) return $notify;

  $notify = Object.assign(function (options) {
    if (options.skipStore) {
      return Notification(options);
    }

    return store.dispatch('notifications/ADD', options);
  }, Notification);

  NOTIFICATION_TYPES.forEach((type) => {
    $notify[type] = ({ skipStore, ...options }) => {
      if (skipStore) {
        return Notification[type](options);
      }
      return store.dispatch('notifications/ADD', { type, ...options });
    };
  });

  return $notify;
};

export default {
  install(app) {
    app.prototype.$notify = getNotify();
  }
};

export function useNotifications() {
  return {
    notify: getNotify()
  };
}
